import { Body } from '@assembly-js/design-system';
import React from 'react';

interface SettingsFieldProps {
  label: string;
  /** The control's id, so clicking the label focuses it. */
  htmlFor?: string;
  children: React.ReactNode;
}

/** A label over a full-width control, for inputs too wide to sit beside their label in a SettingsRow. */
export const SettingsField = ({
  label,
  htmlFor,
  children,
}: SettingsFieldProps) => (
  <div className="flex flex-col gap-1.25">
    <label htmlFor={htmlFor}>
      <Body
        size="sm"
        tag="span"
        className="font-medium leading-[22px] text-black-heading"
      >
        {label}
      </Body>
    </label>
    {children}
  </div>
);
